<template>
	<div class="add_channels_wrap">
    <el-button type="primary" size="small" @click="pop_show = true" class="pull-right">新增频道</el-button>
    <el-dialog title="新增频道" :visible.sync="pop_show" append-to-body>
        <el-form :model="ChannelsForm" status-icon :rules="rulesChannelsForm" ref="ChannelsForm" label-width="100px">
          <el-form-item label="频道名词：" prop="name">
            <el-input type="text" v-model="ChannelsForm.name" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="is_visible">
            <template>
              <el-radio-group v-model="ChannelsForm.is_visible">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('ChannelsForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';
export default {
  name: 'AddChannels',
  data () {
    return {
      pop_show:false,
      group_type_list:[],
      category_list:[],
      ChannelsForm:{
        name:'',
        is_visible:''
      },
      rulesChannelsForm:{
      }
    }
  },
  methods:{
    submitForm(){
        let token = localStorage.token;

        this.axios.post(cons.apis + '/v1_0/channels', {
              "name": this.ChannelsForm.name,
              "is_visible": this.ChannelsForm.is_visible,
              "sequence": 1
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            if(dat.status==201){
              this.$message({
                type: 'success',
                message: '频道添加成功!'
              });
              this.pop_show = false;
              this.resetForm('ChannelsForm');
              this.$emit('fnResetTable');
            }
        }).catch(err=>{
            if(err.response.status==400){
              var errmsg = err.response.data;

              if(errmsg.name){
                this.$message({
                  type:'info',
                  message:errmsg.name[0]
                });
              }

              if(errmsg.non_field_errors){
                this.$message({
                  type:'info',
                  message:errmsg.non_field_errors[0]
                });
              }
           }
        });
    },

    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widget/Addchannels.vue